function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 *
 * @param obj
 * @param key
 * @returns {boolean}
 * duplicates Reflect.has as in:
 *     https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Reflect/has
 */
export var has = function has(obj, key) {
  if (!isObject(obj)) {
    throw new TypeError('param is not an object');
  }

  return key in obj;
};

var isObject = function isObject(obj) {
  return obj !== null && _typeof(obj) === 'object';
};
/**
 *
 * @param obj
 * @returns An Array of the target object's own property keys
 * duplicates Reflect.has as in:
 *     https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Reflect/ownKeys
 */


export var ownKeys = function ownKeys(obj) {
  var tmpRes = [];

  if (!isObject(obj)) {
    throw new TypeError('param is not an object');
  }

  tmpRes = Object.getOwnPropertyNames(obj); //.concat(Object.getOwnPropertySymbols(obj))

  return tmpRes;
};